import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import Icon from '@material-ui/core/Icon';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import { Theme } from '@material-ui/core/styles';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import createStyles from '@material-ui/styles/createStyles';
import makeStyles from '@material-ui/styles/makeStyles';
import React, { useCallback, useContext } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';

import { PrivateLayoutContext } from './Context';
import { PrimaryNavigationItemProps } from './Navigation';
import NavigationList from './NavigationList';

export type NavigationItemProps = {
  item: PrimaryNavigationItemProps;
  toggleOpen?: () => void;
};

const useStyles = makeStyles(() =>
  createStyles({
    icon: {
      minWidth: '36px',
    },
  })
);

const NavigationItem: React.FC<NavigationItemProps> = ({
  item,
  toggleOpen,
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  const { dispatch } = useContext(PrivateLayoutContext);

  const selection = useMatch({
    path: item.path,
  });

  const handleClick = useCallback(() => {
    setOpen(!open);
  }, [open]);

  const url = item.path;
  const isSelected = !!selection;
  const handleNavigation = useCallback(() => {
    if (toggleOpen) toggleOpen();

    if (isSelected) {
      return false;
    }

    navigate(url);

    dispatch({
      type: 'resetBreadcrumbs',
    });
  }, [isSelected, navigate, url, dispatch, toggleOpen]);

  if (!!item.children) {
    return (
      <>
        <ListItem button disabled={item.disabled} onClick={handleClick}>
          <ListItemIcon className={classes.icon}>
            <Icon color="inherit">{item.icon}</Icon>
          </ListItemIcon>
          <ListItemText
            disableTypography
            primary={
              <Typography
                style={{
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                }}
              >
                {item.text}
              </Typography>
            }
          />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Box pl={1}>
            <NavigationList items={item.children} toggleOpen={toggleOpen} />
          </Box>
        </Collapse>
      </>
    );
  }

  return (
    <ListItem
      button
      disabled={item.disabled}
      onClick={handleNavigation}
      selected={!!selection}
    >
      <ListItemIcon className={classes.icon}>
        <Icon color="inherit">{item.icon}</Icon>
      </ListItemIcon>
      <ListItemText
        disableTypography
        primary={
          <Typography
            style={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
            }}
          >
            {item.text}
          </Typography>
        }
      />
    </ListItem>
  );
};

export default React.memo(NavigationItem);
